module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_row_1.82e311f5.png";